<template>
	<div>
		<dialog-form
			:dialogVisible="dialogVisible"
			:attributes="attributes"
			:hideClose="hideClose"
			:showBtn="showBtn"
			@close:dialogVisible="close"
			@confirm="confirm"
		>
			<div slot="main" class="enquiry-source-main">
				<span v-if="attributes.text">{{ attributes.text }}</span>
				<div v-else>
					<el-form :model="Form" ref="Form" :rules="rules">
						<el-form-item prop="marketId">
							<div class="label">填写再营销代码ID自动完成再营销配置</div>
							<el-input v-model="Form.marketId">
								<span
									slot="suffix"
									style="font-size: 12px; color: #f6f; cursor: pointer;"
									@click="getId"
								>
									点击获取</span
								>
							</el-input>
						</el-form-item>
						<el-form-item prop="foreignFirstIndustry">
							<div class="label">确认客户行业，完成行业再营销配置</div>
							<industry
								v-model="Form.foreignFirstIndustry"
								:requestApi="customer.foreigntrade"
							></industry>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</dialog-form>
	</div>
</template>
<script>
import industry from '@/components/customer/industry';
import dialogForm from '@/components/dialogForm/dialogForm';
import customer from '@/backend/services/account/customer';
import website from '@/backend/services/website/website.js';
export default {
	data() {
		var validateIndustry = (rule, value, callback) => {
			if (!value[0]) {
				callback(new Error('请选择一级行业'));
			}  else {
				callback();
			}
			// else if (!value[1]) {
			// 	callback(new Error('请选择二级行业'));
			// }
		};
		return {
			visible: false,
			attr: {},

			customer: customer,
			rules: {
				marketId: [{ required: true, message: '请输入再营销代码ID', trigger: 'blur' }],
				foreignFirstIndustry: [{ validator: validateIndustry, trigger: 'blur' }],
			},
			Form: {
				marketId: '',
				foreignFirstIndustry: [],
			},
		};
	},
	props: {
		dialogVisible: {
			type: Boolean,
		},
		attributes: {
			type: Object,
		},
		showBtn: {
			type: Boolean,
		},
		hideClose: {
			type: Boolean, //是否隐藏取消按钮
		},
		serviceSiteId: {
			type: String,
		},
	},
	methods: {
		//TODO
		//
		confirm(cb) {
			cb(false);
			if (this.attributes.flag == 'marketing' && this.$refs['Form']) {
				this.$refs['Form'].validate(valid => {
					if (valid) {
						this.$emit('bindTipDialogClose', this.attributes, this.Form);
					}
				});
			} else {
				this.$emit('bindTipDialogClose', this.attributes, this.Form);
			}
		},
		close() {
			this.Form.foreignFirstIndustry = [];
			if (this.attributes.flag == 'marketing' && this.$refs['Form']) {
				this.$refs['Form'].resetFields();
			}
			this.$emit('dialogClose');
		},
		async getId() {
			let id = this.serviceSiteId;
			let res = await website.getConversionId({ id });
			if (res) {
				this.Form.marketId = res.data;
			}
		},
	},
	watch: {
		attributes: {
			handler(val) {
				if (val.form) {
					this.Form.marketId = val.form.marketId;
					this.Form.foreignFirstIndustry = val.form.foreignFirstIndustry;
				}
			},
			immediate: true,
		},
	},
	mounted() {},
	components: {
		dialogForm,
		industry,
	},
};
</script>
<style lang="scss" scoped>
.enquiry-source-main {
  text-align: center;
  padding: 15px;

  .label {
    padding-bottom: 20px;
    text-align: left;
  }
}
</style>
